module.exports = __webpack_public_path__ + "img/mbal.0e8ecb30.png";